<div class="onboarding-container">
  <div class="onboarding-card">
    <div class="onboarding-header">
      <h2 class="onboarding-title">ตั้งค่าโปรไฟล์</h2>
      <p class="onboarding-subtitle">กรอกข้อมูลของคุณเพื่อเริ่มใช้งานระบบ</p>
    </div>

    @if (profileError) {
      <div class="profile-alert error">{{ profileError }}</div>
    }
    <!-- Single step: personal info + contact address (role is always USER). -->
    <form #profileForm="ngForm" (ngSubmit)="onSubmit(profileForm)" class="user-profile-form">
          <div class="view-data-card" ngModelGroup="personalInfo">
            <div class="view-card-header">
              <div class="view-card-icon"><i class="bi bi-person"></i></div>
              <span class="view-card-title">ข้อมูลส่วนตัว</span>
            </div>
            <div class="view-card-rows">

              <div class="view-row-group">
                <div class="view-row">
                  <span class="view-label">อีเมล</span>
                  <span class="view-value">{{ profile.personalInfo?.email || '—' }}</span>
                </div>
                <div class="view-row">
                  <span class="view-label">ประเภทบัตร</span>
                  <span
                    class="view-value">{{ getCardTypeLabel(profile.personalInfo?.cardType) || '—' }}</span>
                </div>
                <div class="view-row">
                  <span class="view-label">เลขบัตร</span>
                  <span class="view-value">{{ profile.personalInfo?.cardNo || '—' }}</span>
                </div>
                <div class="view-row">
                  <span class="view-label">วันเดือนปีเกิด</span>
                  <span
                    class="view-value">{{ (profile.personalInfo?.birthdate | thaidatetime: {showTime: false}) || '—' }}</span>
                </div>

                <div class="view-row">
                  <span class="view-label">ชื่อ-นามสกุล</span>
                  <span class="view-value">{{ thaiFullName }}</span>
                </div>
                <div class="view-row">
                  <span class="view-label">ชื่อ-นามสกุล (English)</span>
                  <span class="view-value">{{ engFullName }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="form-section-card">
            <div class="section-card-header">
              <div class="section-card-icon"><i class="bi bi-geo-alt"></i></div>
              <span class="section-card-title">ที่อยู่สำหรับติดต่อ</span>
            </div>
            <div class="section-card-body">
              <div ngModelGroup="address">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label col-form-label-sm ui-require" for="ob-addressNo">ที่อยู่</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control form-control-sm" id="ob-addressNo" name="addressNo"
                           [(ngModel)]="profile.address.addressNo" required>
                    @if (profileForm.form.get('address.addressNo')?.touched && profileForm.form.get('address.addressNo')?.invalid) {
                      <div class="invalid-feedback d-block small">กรุณากรอกที่อยู่</div>
                    }
                  </div>
                </div>
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label col-form-label-sm" for="ob-moo">หมู่ที่</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control form-control-sm" id="ob-moo" name="moo"
                           [(ngModel)]="profile.address.moo">
                  </div>
                </div>
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label col-form-label-sm" for="ob-soi">ตรอก/ซอย</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control form-control-sm" id="ob-soi" name="soi"
                           [(ngModel)]="profile.address.soi">
                  </div>
                </div>
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label col-form-label-sm" for="ob-road">ถนน</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control form-control-sm" id="ob-road" name="road"
                           [(ngModel)]="profile.address.road">
                  </div>
                </div>
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label col-form-label-sm ui-require" for="ob-subdistrict">ตำบล/แขวง</label>
                  <div class="col-sm-8">
                    <app-subdistrict-autocomplete id="ob-subdistrict" name="subDistrict" size="sm"
                                                  [required]="true"
                                                  [(ngModel)]="profile.address.subDistrict"
                                                  (ngModelChange)="onSubDistrictSelect($event)"></app-subdistrict-autocomplete>
                    @if (profileForm.form.get('address.subDistrict')?.touched && profileForm.form.get('address.subDistrict')?.invalid) {
                      <div class="invalid-feedback d-block small">กรุณาเลือกตำบล/แขวง</div>
                    }
                  </div>
                </div>
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label col-form-label-sm" for="ob-districtName">อำเภอ/เขต</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control form-control-sm" id="ob-districtName" name="districtName"
                           [(ngModel)]="profile.address.districtName" disabled readonly>
                  </div>
                </div>
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label col-form-label-sm" for="ob-provinceName">จังหวัด</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control form-control-sm" id="ob-provinceName" name="provinceName"
                           [(ngModel)]="profile.address.provinceName" disabled readonly>
                  </div>
                </div>
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label col-form-label-sm" for="ob-postCode">รหัสไปรษณีย์</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control form-control-sm" id="ob-postCode" name="postCode"
                           [(ngModel)]="profile.address.postCode" maxlength="5" disabled readonly>
                  </div>
                </div>
              </div>
              <div ngModelGroup="personalInfo">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label col-form-label-sm ui-require" for="ob-mobile">มือถือ </label>
                  <div class="col-sm-8">
                    <input type="tel" class="form-control form-control-sm" id="ob-mobile" name="mobile"
                           [(ngModel)]="profile.personalInfo.mobile" maxlength="10" required
                           (input)="onPhoneInput($event, 'mobile')">
                    @if (profileForm.form.get('personalInfo.mobile')?.touched && profileForm.form.get('personalInfo.mobile')?.invalid) {
                      <div class="invalid-feedback d-block small">กรุณากรอกเบอร์มือถือให้ถูกต้อง</div>
                    }
                  </div>
                </div>
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label col-form-label-sm" for="ob-phoneNo">โทรศัพท์</label>
                  <div class="col-sm-8">
                    <input type="tel" class="form-control form-control-sm" id="ob-phoneNo" name="phoneNo"
                           [(ngModel)]="profile.personalInfo.phoneNo" maxlength="10"
                           (input)="onPhoneInput($event, 'phoneNo')">
                  </div>
                </div>
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label col-form-label-sm" for="ob-faxNo">โทรสาร</label>
                  <div class="col-sm-8">
                    <input type="tel" class="form-control form-control-sm" id="ob-faxNo" name="faxNo"
                           [(ngModel)]="profile.personalInfo.faxNo" maxlength="10"
                           (input)="onPhoneInput($event, 'faxNo')">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="onboarding-footer">
            <button type="submit" class="btn btn-primary onboarding-next"
                    [disabled]="profileSaving || profileForm.invalid">
              @if (profileSaving) {
                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              }
              บันทึกข้อมูล
            </button>
          </div>
    </form>
  </div>
</div>
